export const cutString = (
  length: number,
  value?: string,
  addSymbols?: string
) => {
  if (!value) return ''

  return value.length > length
    ? value.slice(0, length) + addSymbols || ''
    : value
}
